import classNames from 'classnames';
import PropTypes from 'prop-types';

import './index.scss';

const loaderSizeMap = {
    large: 64,
    medium: 40,
    small: 26,
};

const Loader = ({ isShow = true, className, style, loaderSize = 'large' }) => {
    return (
        <div
            style={{ display: isShow ? 'flex' : 'none', ...style }}
            className={classNames('loader', className)}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    margin: 'auto',
                    display: 'block',
                    shapeRendering: 'auto',
                    width: loaderSizeMap[loaderSize],
                }}
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
            >
                <circle
                    cx="50"
                    cy="50"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="7"
                    r="37"
                    strokeDasharray="174.35839227423352 60.119464091411174"
                    transform="rotate(298.068 50 50)"
                />
            </svg>
        </div>
    );
};

Loader.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    loaderSize: PropTypes.oneOf(['large', 'medium', 'small']),
};

export default Loader;
